import LooksWidgetConfiguration from './LooksWidgetConfiguration';
import NewLooksWidgetConfiguration from './NewLooksWidgetConfiguration';
import NewRetailersWidgetConfiguration from './NewRetailersWidgetConfiguration';
import RetailersWidgetConfiguration from './RetailersWidgetConfiguration';
import TopLooksWidgetConfiguration from './TopLooksWidgetConfiguration';
import TopRetailersWidgetConfiguration from './TopRetailersWidgetConfiguration';

const WIDGET_TYPES = {
  looks: LooksWidgetConfiguration,
  newest_looks: NewLooksWidgetConfiguration,
  top_looks: TopLooksWidgetConfiguration,
  retailers: RetailersWidgetConfiguration,
  newest_retailers: NewRetailersWidgetConfiguration,
  top_retailers: TopRetailersWidgetConfiguration,
};

export default WIDGET_TYPES;
